import React, { useMemo } from 'react'
import { Box } from '@usap/uicomponents'
import { Title } from '../meta'
import { MainContainer } from './UserInfoMsgWMO.css'

export default function UserInfoMsgWMO({
  bgColor,
  icon = () => {},
  iconColor = 'dark-2',
  infoType,
  textColor = 'dark-2',
  isMobile,
  infoLocation = '',
  style={},
  textStyle={},
  dataTestId='',
  iconSize = {}
}) {
  const infoDataTestId = useMemo(() => {
    if (infoLocation === 'garagePage') {
      if (isMobile) {
        return 'wom-garage-success-msg'
      }

      return 'desktop-garage-success-msg'
    }

    return ''
  }, [infoLocation, isMobile])

  let mainContainerProps = {
    borderColor: bgColor,
    ...(dataTestId && { 'data-testid': dataTestId })
  };

  return (
    <MainContainer
      {...mainContainerProps}
      style={style}
    >
      <Box style={{ width: "100%", height: "auto", display: "flex", flexDirection: "row", alignItems: "flex-start", gap: "4px" }}>
        {icon({
          fill: iconColor,
          ...iconSize,
        })}
        <Title style={{
          ...textStyle,
          color: "#282832", flex: "1", 
        }}
          size="small"
          {...infoDataTestId && { 'data-testid': infoDataTestId }}
          color={textColor}
          dangerouslySetInnerHTML={{ __html: infoType }}
        />
      </Box>
    </MainContainer>
  )
}
